import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './promoStories.module.css';
import { TStories } from './Stories';

type TProgress = {
    count: number;
    currentStep: number;
    isPaused: boolean;
    onStepComplete: () => void;
} & TStories;

// duration = длительность анимации в секундах
const defaultDuration = 2;
// progressChangeInterval = каждые сколько миллисекунд увеличивать ширину прогресса
const progressChangeInterval = 50;

const Progress = (props: TProgress) => {
    const [currentStepProgress, setCurrentStepProgress] = useState(0);
    const { onStepComplete, currentStep } = props;

    const steps = useMemo(() => [...Array(props.count)], [props.count]);

    const duration = props.duration ?? defaultDuration;
    // changesCount = количество шагов таймера для того, чтобы достичь 100%
    const changesCount = (duration * 1000) / progressChangeInterval;
    // increment = на сколько увеличить ширину за каждый шаг таймера
    const increment = 100 / changesCount;

    const updateProgress = useCallback(() => {
        if (!props.isPaused) {
            setCurrentStepProgress((value) => Math.min(value + increment, 100));
        }
    }, [increment, props.isPaused]);

    useEffect(() => {
        if (currentStepProgress === 100) {
            onStepComplete();
        }
    }, [onStepComplete, currentStepProgress]);

    useEffect(() => {
        const intervalId = setInterval(updateProgress, progressChangeInterval);
        return () => clearInterval(intervalId);
    }, [updateProgress]);

    const stepClass = clsx(styles.step, props.isInverted && styles.stepInverted);
    const stepBgClass = clsx(styles.stepBg, props.isInverted && styles.stepBgInverted);
    return (
        <div className={styles.progressRow}>
            {steps.map((_value, index) => {
                const progress = index < currentStep ? 100 : index > currentStep ? 0 : currentStepProgress;
                return (
                    <div className={stepClass} key={index}>
                        <div className={stepBgClass} style={{ width: progress + '%' }} />
                    </div>
                );
            })}
        </div>
    );
};
export { Progress };
